import { useEffect, useState } from "react";
import AppDrawer from "../Drawers/AppDrawer";
import { DrawerProps } from "../Drawers/DrawerTypes";
import {
  CalendarConfig,
  defaultCalendarConfig,
} from "../PageView/AddViewDrawer/AddViewDrawer";
import CalendarConfigComponent from "../PageView/PageViewTable/CalendarConfig";
import { Button } from "reactstrap";
import AppSpinner from "../../elements/AppSpinner";

interface Props extends DrawerProps {
  existingConfig?: CalendarConfig;
  moduleAPIName: string;
  saving: boolean;
  onSaveCalendarConfig: ({
    config,
    onClose,
  }: {
    config: CalendarConfig;
    onClose: () => void;
  }) => void;
}

export default function CalendarLayoutDrawer({
  open,
  onClose,
  existingConfig,
  moduleAPIName,
  saving,
  onSaveCalendarConfig,
}: Props) {
  const [calendarConfig, setCalendarConfig] = useState<CalendarConfig>(
    defaultCalendarConfig()
  );

  useEffect(() => {
    setCalendarConfig(existingConfig || defaultCalendarConfig());
  }, [existingConfig]);

  return (
    <AppDrawer
      open={open}
      onClose={onClose}
      headerTitle={"Calendar Configuration"}
      headerOptions={
        <Button
          color="primary"
          style={{ width: 100 }}
          disabled={saving}
          onClick={() =>
            onSaveCalendarConfig({ config: calendarConfig, onClose: onClose })
          }
        >
          {saving ? <AppSpinner size="sm" /> : "Save"}
        </Button>
      }
      bodyCSS="pt-2"
      body={
        <>
          <CalendarConfigComponent
            calendarConfig={calendarConfig}
            setCalendarConfig={setCalendarConfig}
            moduleAPIName={moduleAPIName}
          />
        </>
      }
    />
  );
}
